import React from 'react'
import type {
  InlineInputContentOptions,
  InlineInputDisplayContent,
  InlineInputEditContent,
  InlineInputProps,
} from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'
import { HoverEditCodeLinks } from '@ztechapps/webui.data-tools'
import { LogisticSelect } from '../Select'
import { LogisticCodeLink } from '../LogisticCodeLink/LogisticCodeLink'

const DisplayContent: InlineInputDisplayContent = (
  initialValues: any,
  onClick: any,
  { canEdit }: InlineInputContentOptions
) => {
  return <HoverEditCodeLinks onClick={onClick} canEdit={canEdit} values={initialValues} CodeLink={LogisticCodeLink} />
}

const EditContent: InlineInputEditContent = ({
  value,
  setNewValue,
  documentId,
  ...props
}: InlineInputContentOptions) => {
  return (
    <LogisticSelect
      {...props}
      filter={{ _id: { $ne: documentId } }}
      onChange={(e) => setNewValue(e)}
      value={value}
      isMulti={true}
      autoFocus
    />
  )
}

export const RelatedLogisticInlineInput = ({
  parentInputComponent,
  initialValues,
  displayContent,
  editContent,
  name = 'relatedLogistics',
  help = 'The related logistics for this item.',
  label = 'Logistics',

  ...props
}: InlineInputProps) => {
  const ParentInput = parentInputComponent || InlineInput

  const mappedInitialValues = {
    ...initialValues,
    [name]: initialValues?.[name]?.map((item) => {
      return {
        ...item,
        value: item?._id,
        label: item.code, //we need this to work with dropdown
      }
    }),
  }

  return (
    <ParentInput
      label={label}
      help={help}
      name={name}
      initialValues={mappedInitialValues}
      displayContent={displayContent ?? DisplayContent}
      editContent={editContent ?? EditContent}
      horizontalLayout
      {...props}
    />
  )
}
